import React from 'react';
import { StepComponentProps } from '@/shared/types/availability';
import { AvailabilityStep } from '@/shared/constants/availability';

import {
  ConnectCalendar,
  Availability,
  Booking,
  Timezone,
  DateSchedule,
} from '@/shared/components/schedule/AvailabilitySteps';

export const STEP_COMPONENTS = {
  [AvailabilityStep.CalendarConnection]: () => <ConnectCalendar />,
  [AvailabilityStep.Availability]: ({
    isAllCompleted,
    onSaveAvailability,
  }: StepComponentProps) => (
    <Availability
      isAllCompleted={isAllCompleted}
      onSaveAvailability={onSaveAvailability}
    />
  ),
  [AvailabilityStep.Booking]: ({
    schedulingData,
    isAllCompleted,
    onSaveAvailability,
  }: StepComponentProps) => (
    <Booking
      schedulingData={schedulingData}
      isAllCompleted={isAllCompleted}
      onSaveAvailability={onSaveAvailability}
    />
  ),
  [AvailabilityStep.TimeZoneSelection]: ({
    isAllCompleted,
    onSaveAvailability,
  }: StepComponentProps) => (
    <Timezone
      isAllCompleted={isAllCompleted}
      onSaveAvailability={onSaveAvailability}
    />
  ),
  [AvailabilityStep.Schedule]: ({
    isAllCompleted,
    onSaveAvailability,
  }: StepComponentProps) => (
    <DateSchedule
      isAllCompleted={isAllCompleted}
      onSaveAvailability={onSaveAvailability}
    />
  ),
};
